module.exports = __webpack_public_path__ + "img/source4.4a4b88b3.png";